import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db9767a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "smaller-fields-container" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = { class: "tab-content" }
const _hoisted_9 = {
  key: 0,
  class: "preview-body-container"
}

import { computed, ref, inject, watch } from 'vue';
import modalBase from '@/components/ui/modals/modal-base.vue';
import { ModalWidth } from '@/types/ui/modals/ModalWidth';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { AcquaintApiClient } from '@/services/AcquaintApiClient';
import { AcquaintApiNextClient } from '@/services/AcquaintApiNextClient';
import displayErrorMessage from '@/utils/ErrorHandling';
import { ValidatedEvent } from 'devextreme/ui/validator';
import { FieldSize } from '@/enums/system/FieldSize';
import SwitchToggle from '@/components/ui/toggles/switch-toggle.vue';
import AcquaintTextbox from '@/components/ui/inputs/acquaint-textbox.vue';
import { EmailsValidation } from 'acquaint-api/validation/EmailsValidation';
import { Emails } from 'acquaint-api/models/Emails';
import SystemCodeSingleSelect from '@/components/ui/system-codes/system-code-single-select.vue';
import { CodeType } from 'acquaint-api/constants/CodeType';
import NumberDropdown from '@/components/ui/dropdowns/number-dropdown.vue';
import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel';
import HtmlEditor from '@/components/html-editor/html-editor.vue';
import { LookupTableSource } from 'acquaint-api/constants/LookupTableSource';
import LookupSingleSelect from '@/components/ui/lookup/lookup-single-select.vue';
import MergeFieldsModal from '@/components/contacts/merge-fields-modal.vue';
import FileUpload from '@/components/ui/inputs/file-upload.vue';
import { saveAs } from 'file-saver-es';
import { EmailTemplateFile } from '@/types/EmailTemplateFile';
import { convertCorrespondenceFileToBlob, getFileNameParts } from '@/utils/files/CorrespondenceFileConverter';
import { FileNameId } from '@/types/FileNameId';
import EmailSignaturesConfigurationModal from '@/components/email/email-signatures-configuration-modal.vue';
import { IDDescriptionPair } from '@/types/generic/IDDescriptionPair';
import AcquaintInfoBox from '@/components/ui/inputs/acquaint-info-box.vue';
import { getErrorMessage } from 'bright-logic-core/src/errors';
import { EmailTemplate } from '@/types/EmailTemplate';
import { DefaultEmailTemplate } from '@/types/DefaultEmailTemplate';
import AITextGeneratorModal from '@/components/ai/ai-text-generator-modal.vue';
import { EmailSignatures } from 'acquaint-api/models/EmailSignatures';
import EmailItemsComponent from '@/components/ui/emails/email-items.vue';
import NewsletterComponent from '@/components/ui/emails/newsletter-articles.vue'
import { EmailItems } from '@/types/emails/EmailItems';
import MailshotItemModal from '@/components/email/mailshot-item-modal.vue';
import { MarketingEmailItemType } from '@/enums/emails/MarketingEmailItemType';
import { EmailItem } from '@/types/emails/EmailItem';
import { displayQuestionAlert } from '@/alerts/questionAlert';
import { UserPermissions } from '@/types/user/permissions/UserPermissions';
import { EmailType } from '@/enums/emails/EmailType';
import { Newsletter } from '@/types/emails/Newsletter';
import NewsletterArticleModal from '@/components/email/newsletter-article-modal.vue';
import { useUserPermissionsStore } from '@/stores/UserPermissionsStore';
import { standardInfoAlert } from '@/alerts/standardInfoAlert';
import { Body } from '@/types/generic/Body';
import { EmailPreviewFields } from '@/types/emails/EmailPreviewFields';
import ScrollView from '@/components/ui/scroll-view.vue';
import DisplayHtml from '@/components/ui/display-html.vue';
import { PropertyBulletinPreview } from '@/types/emails/PropertyBulletinPreview';


export default /*#__PURE__*/_defineComponent({
  __name: 'new-edit-email-templates-modal',
  props: {
    /** 
     * The boolean value used with `v-model` to control the visibility or state of a modal or component.
     * @type {boolean}
     * @required
     */
    modelValue: {
        type: Boolean,
        required: true
    },
    /** 
     * The unique identifier for the email template.
     * @type {number}
     * @required
     */
    configurationId: {
        type: Number,
        required: true
    }
},
  emits: [
    /** 
     * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
     * @property {boolean} value - Indicates whether the modal has been opened or closed.
     */
    'update:modelValue',
    /** 
     * Emitted when an existing template configuration  has been successfully edited.
     * This notifies the parent component to refresh or update the template configuration details.
     * @property {boolean} inActive - Indicates whether the template configuration is inactive after the edit.
     */
    'configurationItemEdited',
    /** 
     * Emitted when a new template configuration has been successfully created.
     * This notifies the parent component to handle the creation of a new template configuration.
     */
    'configurationItemCreated'
],
  setup(__props, { emit }) {

const props = __props;





const displayCloseConfirmationPrompt = ref(false);
const originalItemData = ref<EmailTemplate>();
const itemData = ref<EmailTemplate>();
const lockedByAnotherUser = ref(false)
const keepingModalOpening = ref(false);
const submissionResponse = ref<Emails>();
const selectedTab = ref(0);
const previewFieldValue = ref('');
const addMergeFieldToSubject = ref(true);
const openMergeFieldsModal = ref(false);
const bodyMergeFieldToAdd = ref('');
const attachmentsList = ref<EmailTemplateFile[]>([]);
const resetAttachments = ref(false);
const displaySignaturesModal = ref(false);
const displayAIModal = ref(false);
const emailSignature = ref<EmailSignatures>();
const selectedSignature = ref<IDDescriptionPair>({ id: -1, description: '' });
//Email items variables
const userPermissionsStore = useUserPermissionsStore();
const displayMailshotModal = ref(false);
const userPermissions = ref<UserPermissions>();
const emailItemType = ref<MarketingEmailItemType>();
const emailItemActionKey = ref<string>();
// const showPreviewContent = ref(false);

const initialEmailItem = {
    marketingEmailItemId: 0,
    description: '',
    displayOrder: 0,
    url: ''
};

const selectedEmailItem = ref<EmailItem>({ ...initialEmailItem });
const selectedMenuItemsEmailItem = ref<EmailItem>({ ...initialEmailItem });
const selectedAdvertsEmailItem = ref<EmailItem>({ ...initialEmailItem });

//Preview Tab
const emailPreviewFields = ref<EmailPreviewFields>({
    subject: "",
    body: ""
});
const propertyBulletinText = ref<PropertyBulletinPreview>({
    body: '',
    noPropertiesFound: false
});

const propertyDetails = ref<Body>({ body: '' });

// File objects that are only populated when the record is being saved and the appropriate files
// need to be submitted to the save and delete attachment APIs
const filesToSubmitToApi = ref(new FormData());

// This lists files to be submitted to the APIs before they are added to the FormData objects.
// I thought it would be worth having these so it is easy to add and remove items from the list
const filesToUpload = ref<File[]>([]);
const filesToDelete = ref<number[]>([]);

// The value of the ref is set when a file is double selected and downloaded.
const downloadedFile = ref<EmailTemplateFile>();

// List of all attached files including all those saved in the database and those added to the
// list when the modal is in edit mode but not yet added to the database
const filesDisplayed = ref<File[]>([]);
// We have the original version so that we can determine which files were fetched from the API and
// therefore which files should populate the filesToDelete and filesToUpload lists be uploaded
// or deleted
const originalFilesIdsNames = ref<FileNameId[]>([]);

const acquaintApiClient = inject('AcquaintApiClient') as AcquaintApiClient;
const acquaintApiNextClient = inject('AcquaintApiNextClient') as AcquaintApiNextClient;

const showModal = computed({
    get: () => props.modelValue,
    set: (value: Boolean) => emit('update:modelValue', value)
});


// The following functions are involved in fetching and displaying the correct data in the form

const lockConfigurationItem = async () => {
    try {
        await acquaintApiClient.httpPostVoid(`database/emails/${props.configurationId}/lock`, { lock: true, extraInfo: '' });
        return true;
    } catch (err) {
        lockedByAnotherUser.value = true;
        displayErrorMessage('These details are already being edited by another user.');
        return false;
    }
};

const unLockConfigurationItem = async () => {
    try {
        await acquaintApiClient.httpPostVoid(`database/emails/${props.configurationId}/lock`, { lock: false, extraInfo: '' });
    } catch (err) {
        displayErrorMessage('We were unable to unlock these details.');
    }
};

const fetchItemData = async () => {
    try {
        if (props.configurationId == 0) {
            const defaultData = await acquaintApiClient.httpGet<DefaultEmailTemplate>(`database/emails/defaultmodel`);

            /* As the default email template endpoint returns slightly different fieldnames to the email templates endpoint, 
             * we need to map some fields manually */
            originalItemData.value = {
                ...defaultData,
                emailSignatureId: defaultData.emailSignatureID,
                contentTypeId: defaultData.contentTypeID,
                typeId: defaultData.typeID,
                autoAttachDocumentId: defaultData.autoAttachDocumentID,
                mailshotGroupId: defaultData.mailshotGroupID
            }
        } else {
            originalItemData.value = await acquaintApiNextClient.httpGet<EmailTemplate>(`EmailTemplates/${props.configurationId}`);
        }
    } catch (err) {
        originalItemData.value = undefined;
        itemData.value = undefined;
        if (props.configurationId > 0) {
            displayErrorMessage('The selected details could not be fetched');
        } else {
            displayErrorMessage('We could not fetch the default data');
        }
    }
};

const fetchSignature = async () => {
    try {
        selectedSignature.value = await acquaintApiClient.httpGet<IDDescriptionPair>(`app/system/lookup/${LookupTableSource.EmailSignatures}/${itemData.value?.emailSignatureId}`);
    } catch (err) {
        selectedSignature.value = { id: -1, description: '' };
        displayErrorMessage(getErrorMessage(err));
    }
};

const fetchEmailSignatureHeaderFooter = async () => {
    try {
        emailSignature.value = await acquaintApiNextClient.httpGet(`EmailSignatures/${itemData.value?.emailSignatureId}`)
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        emailSignature.value = undefined;
    }
};

const fetchEmailAttachmentsList = async () => {
    try {
        attachmentsList.value = await acquaintApiNextClient.httpGet(`email/${props.configurationId}/emailattachments`);
    } catch (err) {
        displayErrorMessage('The attachments list could not be fetched.');
        attachmentsList.value = [];
    }
};

const populateDisplayedAttachmentsList = async () => {
    await fetchEmailAttachmentsList();

    await populateOriginalAttachmentsList();
};

const populateOriginalAttachmentsList = async () => {

    if (attachmentsList.value.length > 0) {

        attachmentsList.value.forEach((file) => {
            const fileName = getFileNameParts(file.attachedFile.fileDownloadName);

            if (!fileName) {
                return;
            }

            originalFilesIdsNames.value.push({ id: file.id, name: fileName.name });
            filesDisplayed.value.push(new File([file.attachedFile.fileContents], fileName.name, { type: file.attachedFile.contentType }));
        });
    }
};

watch(()=>itemData.value, ()=>{
    displayCloseConfirmationPrompt.value = JSON.stringify(itemData.value) != JSON.stringify(originalItemData.value);
}, {deep: true})

watch(() => showModal.value, async () => {
    if (!props.modelValue || keepingModalOpening.value) {
        return
    }

    if (showModal.value) {
        displayCloseConfirmationPrompt.value = false;
        selectedTab.value = 0;
        previewFieldValue.value = '';
        lockedByAnotherUser.value = false;
        addMergeFieldToSubject.value = true;
        attachmentsList.value = [];
        filesDisplayed.value = [];
        originalFilesIdsNames.value = [];
        filesToUpload.value = [];
        filesToDelete.value = [];
        filesToSubmitToApi.value = new FormData();
        resetAttachments.value = true;
        selectedSignature.value = { id: -1, description: '' };
        setTimeout(() => { resetAttachments.value = false }, 100);

        await fetchNewletterItems();
        await fetchEmailItems();
        await fetchItemData();
        await fetchSignature();
        if (originalItemData.value) {
            originalItemData.value.emailSignatureId = selectedSignature.value.id;
            itemData.value = JSON.parse(JSON.stringify(originalItemData.value));
        }
        await updatePreview();

        await populateDisplayedAttachmentsList();
        userPermissions.value = await userPermissionsStore.getUserPermissions();
        if (props.configurationId == 0) {
            return;
        }

        await lockConfigurationItem();
    }
});


// The following functions are involved in saving the form data 

const saveDetails = async (e: any) => {
    const validation: ValidatedEvent = e.validationGroup.validate();
    // Don't continue if user has entered invalid data
    if (!validation.isValid) {
        return;
    }

    if (filesToUpload.value.length > 0) {
        filesToUpload.value.forEach((file) => {
            filesToSubmitToApi.value.append(file.name, file);
        });

        await createEmailAttachments(filesToSubmitToApi.value);
    }

    for (let i = 0; i < filesToDelete.value.length; i++) {
        await deleteEmailAttachments(filesToDelete.value[i]);
    }

    if (!await callSaveApi()) {
        return;
    }

    lockedByAnotherUser.value = true;
    displayCloseConfirmationPrompt.value = false;

    if (props.configurationId > 0) {
        await unLockConfigurationItem();
        emit('configurationItemEdited', itemData.value?.inActive);
    } else {
        emit('configurationItemCreated');
    }

    showModal.value = false;
};

const createEmailAttachments = async (files: FormData) => {
    try {
        await acquaintApiNextClient.sendFormData(`email/${props.configurationId}/emailattachments`, files)
    } catch (err) {
        displayErrorMessage(`The added attachments could not be created.`)
    }
};

const deleteEmailAttachments = async (id: number) => {
    try {
        await acquaintApiNextClient.httpDelete(`email/${id}/deleteemailattachment`, null)
    } catch (err) {
        displayErrorMessage(`The removed attachments could not be deleted.`)
    }
};

const callSaveApi = async () => {
    try {
        if (props.configurationId == 0) {
            submissionResponse.value = await acquaintApiClient.httpPost<Emails>(`database/emails`, itemData.value);
        } else {
            submissionResponse.value = await acquaintApiClient.httpPut<Emails>(`database/emails/${props.configurationId}`, itemData.value);
        }
        return true;
    } catch (err) {
        if (props.configurationId == 0) {
            displayErrorMessage('A new system item could not be created.');
        } else {
            displayErrorMessage('The selected details could not be edited.');
        }
        return false;
    }
};

// Other functions
const cancelClick = () => {
    showModal.value = false;
};

const keepEnteredInformation = () => {
    keepingModalOpening.value = true;
};

const cancelPromptDenied = () => {
    keepingModalOpening.value = true;
};

const modalClosed = async () => {
    if (props.configurationId > 0) {
        await unLockConfigurationItem();
    }
    keepingModalOpening.value = false;
};


// These functions are involved in inserting merge fields into the appropriate fields.

const subjectFieldFocused = () => {
    addMergeFieldToSubject.value = true;
};

const bodyFieldFocused = () => {
    addMergeFieldToSubject.value = false;
};

const insertField = () => {
    openMergeFieldsModal.value = true
};

const addMergeField = (mergeField: String) => {
    if (!itemData.value) {
        return;
    }

    if (addMergeFieldToSubject.value && itemData.value) {
        itemData.value.subject = `${itemData.value.subject} [${mergeField}]`;
        return;
    }

    bodyMergeFieldToAdd.value = `[${mergeField}]`;

    setTimeout(() => { bodyMergeFieldToAdd.value = '' }, 250)
};


// Double clicking a file should download it.
// First, we must check if the file to be downloaded is present in the original list of files fetched from the API.
// If it's present we can use the API to downloard the file so that we can get the correct file extension, otherwise,
// we just use the saveAs method. 
const downloadAttachment = async (fileToDownload: File) => {
    const fileNameId = originalFilesIdsNames.value.find((record) => { return record.name == fileToDownload.name });

    if (!fileNameId) {
        saveAs(fileToDownload, fileToDownload.name);
        return;
    }

    await callDownloadApi(fileNameId.id);

    if (!downloadedFile.value) {
        return;
    }

    const blobToDownload = convertCorrespondenceFileToBlob(downloadedFile.value.attachedFile);
    const fileNameParts = getFileNameParts(downloadedFile.value.attachedFile.fileDownloadName);

    if (fileNameParts) {
        saveAs(blobToDownload, fileNameParts.nameWithExtension);
    }
};

const callDownloadApi = async (id: number) => {
    try {
        downloadedFile.value = await acquaintApiNextClient.httpGet(`email/${id}/emailattachment`)
    } catch (err) {
        displayErrorMessage('The attachment could not be downloaded.');
        downloadedFile.value = undefined;
    }
};

const populateToSubmitList = async (e: File[]) => {
    // If a file in the file uploader component cannot be found in the list we have in this form component, that indicates
    // the file has been added. We need to add it to a list of files to submit when the template data is saved.

    for (let i = 0; i < e.length; i++) {
        const foundFile = filesDisplayed.value.find((displayedFile) => { return e[i].name == displayedFile.name });

        if (foundFile) {
            continue;
        }

        filesToUpload.value.push(e[i]);
    }
};

const populateToDeleteList = async (e: File[]) => {
    // If we have a file in the list file here but not in the file uploader component, that inicates that the file
    // has been deleted as this second component has the most recent list of files.

    for (let i = 0; i < filesDisplayed.value.length; i++) {
        // If the file is in both lists, we want to continue the loop to handle the next file in 
        // the loop
        const fileToBeKept = e.find((file) => { return file.name == filesDisplayed.value[i].name });
        if (fileToBeKept) {
            continue;
        }

        const isFileInOriginalList = originalFilesIdsNames.value.find((file) => { return file.name == filesDisplayed.value[i].name });

        // If the file was fetched from the API, we must add it to this list to delete it from the database
        // Otherwise, we must remove the file from the filesToUpload list to prevent it from being uploaded
        if (isFileInOriginalList) {
            filesToDelete.value.push(isFileInOriginalList.id);
        } else {
            filesToUpload.value = filesToUpload.value.filter((file) => { return file.name != filesDisplayed.value[i].name });
        }
    }
};

// This functions ensures the correct list of files is saved by the APIs.
const filesUpdated = async (e: File[]) => {
    if (!e || e && e.length == 0) {
        if (e.length < filesDisplayed.value.length) {
            await populateToDeleteList(e);
        }
        filesDisplayed.value = [...e];
        return;
    }

    // If the most recent version of the file list (e) has fewer files than filesDisplayed, a file
    // has been removed, otherwise, a file has been added.
    if (e.length < filesDisplayed.value.length) {
        await populateToDeleteList(e);
    } else if (e.length > filesDisplayed.value.length) {
        await populateToSubmitList(e);
    }

    filesDisplayed.value = [...e];
};

// We must update the displayed signature and the id of the object to be saved.
const signatureSelected = (e: IDDescriptionPair) => {
    if (!e || !itemData.value) {
        selectedSignature.value = { id: -1, description: '' };
        return;
    }
    selectedSignature.value = e;
    itemData.value.emailSignatureId = e.id;
};

// This code takes the body text and selected email signature to set the preview text.
watch(() => itemData.value?.body, async () => {
    await updatePreview();
});

watch(() => itemData.value?.emailSignatureId, async () => {
    await updatePreview();
});

const getPreviewForStandardEmail = async () => {
    await fetchEmailSignatureHeaderFooter();
    if (itemData.value && emailSignature.value) {
        previewFieldValue.value = emailSignature.value?.header != '' ? `${emailSignature.value?.header}<br />${itemData.value.body}` : itemData.value.body;

        if (emailSignature.value?.body == '') {
            return;
        }

        previewFieldValue.value = previewFieldValue.value + `<br />${emailSignature.value?.body}`;
    }
};

//Email Items Tab variables and methods
const emailItems = ref<EmailItems>({
    menuItems: [],
    adverts: []
});
const fetchEmailItems = async () => {
    try {
        if (!props.configurationId) {
            return;
        }
        emailItems.value = await acquaintApiNextClient.httpGet(`emailItems/${props.configurationId}`);
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        emailItems.value = {
            menuItems: [],
            adverts: []
        };
    }
}

const onMenuItemsRowDbClick = (selectedRow: EmailItem) => {
    selectedMenuItemsEmailItem.value = selectedRow;
    selectedEmailItem.value = selectedRow;
    emailItemType.value = MarketingEmailItemType.MenuItem;
    editEmailItem('mn-edit');
};
const onMenuItemsRowSelected = (selectedRow: EmailItem) => {
    emailItemType.value = MarketingEmailItemType.MenuItem;
    selectedMenuItemsEmailItem.value = selectedRow;
}

const onMenuItemsDropdownClicked = async (key: string) => {
    emailItemType.value = MarketingEmailItemType.MenuItem;
    emailItemsDropdownClicked(key);
};

const onAdvertsRowDbClick = (selectedRow: EmailItem) => {
    emailItemType.value = MarketingEmailItemType.Advert;
    selectedAdvertsEmailItem.value = selectedRow;
    selectedEmailItem.value = selectedRow;
    editEmailItem('ad-edit');
};


const onAdvertsRowSelected = (selectedRow: EmailItem) => {
    emailItemType.value = MarketingEmailItemType.Advert;
    selectedAdvertsEmailItem.value = selectedRow;
}

const onAdvertsDropdownClicked = async (key: string) => {
    emailItemType.value = MarketingEmailItemType.Advert;
    emailItemsDropdownClicked(key);
};

const emailItemsDropdownClicked = async (key: string) => {
    switch (key) {
        case 'ad-new':
        case 'mn-new':
            createEmailItem(key);
            break;
        case 'ad-edit':
            selectedEmailItem.value = selectedAdvertsEmailItem.value;
            editEmailItem(key);
            break;
        case 'mn-edit':
            selectedEmailItem.value = selectedMenuItemsEmailItem.value;
            editEmailItem(key);
            break;
        case 'ad-delete':
            selectedEmailItem.value = selectedAdvertsEmailItem.value;
            deleteEmailItem(key);
            break;
        case 'mn-delete':
            selectedEmailItem.value = selectedMenuItemsEmailItem.value;
            deleteEmailItem(key);
            break;
        case 'ad-refresh':
        case 'mn-refresh':
            await onRefreshEmailItemsData();
            break;
    }
}

const editEmailItem = (key: string) => {
    if (!selectedEmailItem.value.marketingEmailItemId) {
        standardInfoAlert('Please select an item to edit.');
        return;
    }
    emailItemActionKey.value = key;
    displayMailshotModal.value = true;
};

const deleteEmailItem = async (key: string) => {
    if (!userPermissions.value || !userPermissions.value.contactsConfiguration.delete) {
        displayErrorMessage("Sorry, you do not have the permission to delete this item.");
        return;
    }
    if (!selectedEmailItem.value.marketingEmailItemId) {
        standardInfoAlert('Please select an item to delete.');
        return;
    }
    const question = await displayQuestionAlert('Are you sure you want to delete this item?');

    if (!question.isConfirmed) {
        return;
    }

    if (await callDeletApi()) {
        await fetchEmailItems();
        selectedEmailItem.value = { ...initialEmailItem };
        if (key == 'ad-delete') {
            selectedAdvertsEmailItem.value = { ...initialEmailItem };
        } else if (key == 'mn-delete') {
            selectedMenuItemsEmailItem.value = { ...initialEmailItem };
        }

        await updatePreview();
    }
};

const callDeletApi = async () => {
    try {
        if (!await lockEmailItem()) {
            return false;
        }
        await acquaintApiClient.httpDeleteVoid(`database/emailitems/${props.configurationId}/${selectedEmailItem.value.marketingEmailItemId}`);
        return true;
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
    }
};

const createEmailItem = (key: string) => {
    emailItemActionKey.value = key;
    displayMailshotModal.value = true;
};

const onRefreshEmailItemsData = async () => {
    await fetchEmailItems();
    selectedEmailItem.value = { ...initialEmailItem };
    displayMailshotModal.value = false;

    await updatePreview();
}

const lockEmailItem = async () => {
    try {
        if (!selectedEmailItem.value.marketingEmailItemId) return;

        await acquaintApiClient.httpPostVoid(`database/emailitems/${props.configurationId}/${selectedEmailItem.value.marketingEmailItemId}/lock`, { lock: true, extraInfo: '' });
        return true;
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
    }
};

//Newsletter article variables and methods
const displayNewsletterModal = ref(false);
const newsletterActionKey = ref('');
const initialNewsletterItem = {
    newsId: 0,
    subject: '',
    displayOrder: 0
}
const selectedNewsletterItem = ref<Newsletter>({ ...initialNewsletterItem });

const initialNewsletterItems = [
    {
        newsId: 0,
        subject: '',
        displayOrder: 0
    }
];
const emailNewsletterItems = ref<Newsletter[]>([...initialNewsletterItems]);

const fetchNewletterItems = async () => {
    try {
        if (!props.configurationId) {
            return;
        }
        emailNewsletterItems.value = await acquaintApiNextClient.httpGet<Newsletter[]>(`emails/${props.configurationId}/newsletter/items`);
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        emailNewsletterItems.value = [...initialNewsletterItems];
    }
}

const onNewsletterRowSelected = (e: Newsletter) => {
    selectedNewsletterItem.value = e;
}

const onNewsletterRowDbClick = (e: Newsletter) => {
    newsletterActionKey.value = 'edit';
    selectedNewsletterItem.value = e;
    editNewsletterItem();
}
const onNewsletterMenuItemClicked = async (key: string) => {
    switch (key) {
        case 'new':
            createNewsletterItem();
            break;
        case 'edit':
            editNewsletterItem();
            break;
        case 'delete':
            deleteNewsletterItem();
            break;
        case 'refresh':
            await onRefreshNewsletterData();
            break;
    }
}

const createNewsletterItem = () => {
    newsletterActionKey.value = 'new';
    displayNewsletterModal.value = true;
};

const editNewsletterItem = () => {
    if (!selectedNewsletterItem.value.newsId) {
        standardInfoAlert('Please select an item to edit.');
        return;
    }
    newsletterActionKey.value = 'edit';
    displayNewsletterModal.value = true;
};

const onRefreshNewsletterData = async () => {
    await fetchNewletterItems();
    selectedNewsletterItem.value = { ...initialNewsletterItem };
    displayNewsletterModal.value = false;

    await updatePreview();
}

const deleteNewsletterItem = async () => {
    if (!userPermissions.value || !userPermissions.value.contactsConfiguration.delete) {
        displayErrorMessage("Sorry, you do not have the permission to delete this item.");
        return;
    }

    if (!selectedNewsletterItem.value.newsId) {
        standardInfoAlert('Please select an item to delete.');
        return;
    }

    const question = await displayQuestionAlert('Are you sure you want to delete this item?');

    if (!question.isConfirmed) {
        return;
    }

    if (await callDeletNewsletterApi()) {
        await fetchNewletterItems();
        await updatePreview();
        selectedNewsletterItem.value = { ...initialNewsletterItem };
    }
};

const callDeletNewsletterApi = async () => {
    try {
        if (!await lockNewsletterItem()) {
            return false;
        }
        await acquaintApiClient.httpDeleteVoid(`database/EmailNewsletterItems/${props.configurationId}/${selectedNewsletterItem.value.newsId}`);
        return true;
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
    }
};
const lockNewsletterItem = async () => {
    try {
        if (!selectedNewsletterItem.value.newsId) return;

        await acquaintApiClient.httpPostVoid(`database/EmailNewsletterItems/${props.configurationId}/${selectedNewsletterItem.value.newsId}/lock`, { lock: true, extraInfo: '' });
        return true;
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
    }
};

const updatePreview = async () => {
    if (itemData.value?.typeId == EmailType.PropertyBulletinAll || itemData.value?.typeId == EmailType.PropertyBulletinMatched) {
        await fetchPropertyBulletinText();
        emailPreviewFields.value.body = propertyBulletinText.value.body;
    }
    else if (itemData.value?.typeId == EmailType.PropertyDetails) {
        await fetchPropertyDetails();
        emailPreviewFields.value.body = propertyDetails.value.body;
    } else if (itemData.value?.typeId == EmailType.Newsletter) {
        const newsLetterBody: Body = await fetchNewsLetterPreviewBody();
        emailPreviewFields.value.body = newsLetterBody.body;
    } else {
        await getPreviewForStandardEmail();
    }
};

const fetchPropertyBulletinText = async () => {
    try {
        propertyBulletinText.value = await acquaintApiClient.httpPost(`app/correspondence/email/propertybulletin`, {
            contactId: 0,
            templateId: props.configurationId,
            includeValuations: true,
            includeInstructed: true,
            body: itemData.value?.body
        });
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        propertyBulletinText.value = { body: '', noPropertiesFound: false };
    }
};

const fetchPropertyDetails = async () => {
    try {
        propertyDetails.value = await acquaintApiClient.httpPost('app/correspondence/email/propertydetails', {
            templateId: props.configurationId,
            propertyId: 0,
            body: itemData.value?.body
        });
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        propertyDetails.value = { body: '' }
    }
};

const fetchNewsLetterPreviewBody = async (): Promise<Body> => {
    try {
        return await acquaintApiClient.httpPost<Body>('app/correspondence/email/newsletter', {
            templateId: props.configurationId,
            body: itemData.value?.body
        });
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return { body: '' };
    }
};

const onAdvertRowReorder = async (e: any) => {
    reOrderMenuItemsOrAdvertList(e, emailItems.value.adverts)
};
const onMenuItemsRowReorder = async (e: any) => {
    reOrderMenuItemsOrAdvertList(e, emailItems.value.menuItems)
};
const reOrderMenuItemsOrAdvertList = async (e: any, list: EmailItem[]) => {
    const visibleRows = e.component.getVisibleRows();
    const toIndex = list.findIndex((item) => item.marketingEmailItemId === visibleRows[e.toIndex].data.marketingEmailItemId);
    await callEditEmailItemApi(toIndex + 1, e.itemData.marketingEmailItemId);
    fetchEmailItems();
    await updatePreview();
};

const callEditEmailItemApi = async (newOrderPosition: number, recordId: number) => {
    try {
        await acquaintApiClient.httpPut<EmailItems>(`database/emailItems/${props.configurationId}/${recordId}`, {
            emailID: props.configurationId,
            marketingEmailItemID: recordId,
            displayOrder: newOrderPosition
        });
        return true;
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
    }
};

const onNewsLetterRowReorder = async (e: any) => {
    const visibleRows = e.component.getVisibleRows();
    const toIndex = emailNewsletterItems.value.findIndex((item) => item.newsId === visibleRows[e.toIndex].data.newsId);
    await callEditEmailNewsletterApi(toIndex + 1, e.itemData.newsId);
    fetchNewletterItems();
    await updatePreview();
};

const callEditEmailNewsletterApi = async (newOrderPosition: number, newsId: number) => {
    try {
        await acquaintApiClient.httpPut(`database/EmailNewsletterItems/${props.configurationId}/${newsId}`, {
            emailID: props.configurationId,
            newsID: newsId,
            displayOrder: newOrderPosition
        });
        return true;
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
    }
};

const onTypeChanged = async () => {
    await updatePreview();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(modalBase, {
      title: "Email Templates",
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showModal).value = $event)),
      showCloseButton: true,
      showCloseConfirmationPrompt: displayCloseConfirmationPrompt.value,
      height: "630px",
      onCancelConfirmationModal: keepEnteredInformation,
      onModalClosed: modalClosed,
      width: _unref(ModalWidth).Large,
      onCancelPromptDenied: cancelPromptDenied
    }, {
      "non-scrollable-content": _withCtx(() => [
        (itemData.value)
          ? (_openBlock(), _createBlock(_unref(DxTabPanel), {
              key: 0,
              "scroll-by-content": true,
              "show-nav-buttons": true,
              "swipe-enabled": false,
              selectedIndex: selectedTab.value,
              "onUpdate:selectedIndex": _cache[17] || (_cache[17] = ($event: any) => ((selectedTab).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxItem), { title: "General" }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_1, [
                      _createVNode(AcquaintTextbox, {
                        fieldValidation: _unref(EmailsValidation).Description,
                        label: "Description",
                        modelValue: itemData.value.description,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemData.value.description) = $event)),
                        readOnly: lockedByAnotherUser.value,
                        validationGroup: "EmailsValidationGroup"
                      }, null, 8, ["fieldValidation", "modelValue", "readOnly"]),
                      _createElementVNode("section", _hoisted_2, [
                        _createVNode(AcquaintInfoBox, {
                          icon: "chevrondown",
                          label: "Signature",
                          text: selectedSignature.value.description,
                          width: _unref(FieldSize).Large,
                          onIconClicked: _cache[1] || (_cache[1] = ($event: any) => (displaySignaturesModal.value = true))
                        }, null, 8, ["text", "width"]),
                        _createVNode(LookupSingleSelect, {
                          label: "Group",
                          lookupSource: _unref(LookupTableSource).TemplateGroups,
                          modelValue: itemData.value.mailshotGroupId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemData.value.mailshotGroupId) = $event)),
                          width: _unref(FieldSize).Large
                        }, null, 8, ["lookupSource", "modelValue", "width"]),
                        _createVNode(SystemCodeSingleSelect, {
                          "code-type": _unref(CodeType).ContentType,
                          fieldValidation: _unref(EmailsValidation).ContentTypeID,
                          label: "Content Type",
                          modelValue: itemData.value.contentTypeId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((itemData.value.contentTypeId) = $event)),
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup"
                        }, null, 8, ["code-type", "fieldValidation", "modelValue", "width", "readOnly"]),
                        _createVNode(NumberDropdown, {
                          modelValue: itemData.value.followUpTaskInterval,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((itemData.value.followUpTaskInterval) = $event)),
                          itemNumber: 360,
                          itemLabelExtension: "Days",
                          label: "Follow-up Task Interval",
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup"
                        }, null, 8, ["modelValue", "width", "readOnly"]),
                        _createVNode(SystemCodeSingleSelect, {
                          "code-type": _unref(CodeType).TaskPriority,
                          label: "Follow-up Task Priority",
                          modelValue: itemData.value.followUpTaskPriority,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((itemData.value.followUpTaskPriority) = $event)),
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup"
                        }, null, 8, ["code-type", "modelValue", "width", "readOnly"]),
                        _createVNode(SystemCodeSingleSelect, {
                          "code-type": _unref(CodeType).EmailType,
                          fieldValidation: _unref(EmailsValidation).TypeID,
                          label: "Type",
                          modelValue: itemData.value.typeId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((itemData.value.typeId) = $event)),
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup",
                          onValueChanged: onTypeChanged
                        }, null, 8, ["code-type", "fieldValidation", "modelValue", "width", "readOnly"]),
                        _createVNode(AcquaintTextbox, {
                          fieldValidation: _unref(EmailsValidation).FromEmail,
                          label: "From Email",
                          modelValue: itemData.value.fromEmail,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((itemData.value.fromEmail) = $event)),
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup"
                        }, null, 8, ["fieldValidation", "modelValue", "width", "readOnly"]),
                        _createVNode(AcquaintTextbox, {
                          fieldValidation: _unref(EmailsValidation).CC,
                          label: "CC Email",
                          modelValue: itemData.value.cc,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((itemData.value.cc) = $event)),
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup"
                        }, null, 8, ["fieldValidation", "modelValue", "width", "readOnly"]),
                        _createVNode(AcquaintTextbox, {
                          fieldValidation: _unref(EmailsValidation).BCC,
                          label: "BCC Email",
                          modelValue: itemData.value.bcc,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((itemData.value.bcc) = $event)),
                          width: _unref(FieldSize).Large,
                          readOnly: lockedByAnotherUser.value,
                          validationGroup: "EmailsValidationGroup"
                        }, null, 8, ["fieldValidation", "modelValue", "width", "readOnly"])
                      ]),
                      _createVNode(SwitchToggle, {
                        label: "Save as Correspondence",
                        labelWidth: "9.5rem",
                        modelValue: itemData.value.saveAsCorrespondence,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((itemData.value.saveAsCorrespondence) = $event)),
                        readOnly: lockedByAnotherUser.value
                      }, null, 8, ["modelValue", "readOnly"]),
                      _createVNode(SwitchToggle, {
                        label: "New Properties Only",
                        labelWidth: "9.5rem",
                        modelValue: itemData.value.newPropertiesOnly,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((itemData.value.newPropertiesOnly) = $event)),
                        readOnly: lockedByAnotherUser.value
                      }, null, 8, ["modelValue", "readOnly"]),
                      _createVNode(SwitchToggle, {
                        label: "Inactive",
                        labelWidth: "9.5rem",
                        modelValue: itemData.value.inActive,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((itemData.value.inActive) = $event)),
                        readOnly: lockedByAnotherUser.value
                      }, null, 8, ["modelValue", "readOnly"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: "Email" }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_3, [
                      _createVNode(AcquaintTextbox, {
                        fieldValidation: _unref(EmailsValidation).Subject,
                        label: "Subject",
                        modelValue: itemData.value.subject,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((itemData.value.subject) = $event)),
                        readOnly: lockedByAnotherUser.value,
                        validationGroup: "EmailsValidationGroup",
                        onOnFocused: subjectFieldFocused
                      }, null, 8, ["fieldValidation", "modelValue", "readOnly"]),
                      _createVNode(HtmlEditor, {
                        label: "Body",
                        modelValue: itemData.value.body,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((itemData.value.body) = $event)),
                        insertTextAtCursorPosition: bodyMergeFieldToAdd.value,
                        onOnFocused: bodyFieldFocused,
                        "display-a-i-modal": true,
                        onAiIconClick: _cache[15] || (_cache[15] = () => displayAIModal.value = true)
                      }, null, 8, ["modelValue", "insertTextAtCursorPosition"])
                    ])
                  ]),
                  _: 1
                }),
                (itemData.value.id > 0 && itemData.value.typeId !== _unref(EmailType).FreeFormat)
                  ? (_openBlock(), _createBlock(_unref(DxItem), {
                      key: 0,
                      title: "Menu Items"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("section", _hoisted_4, [
                          _createVNode(EmailItemsComponent, {
                            "data-source": emailItems.value?.menuItems,
                            "group-header": 'Menu Items',
                            "alias-name": 'mn',
                            onRowClick: onMenuItemsRowDbClick,
                            onRowSelected: onMenuItemsRowSelected,
                            onMenuItemClick: onMenuItemsDropdownClicked,
                            onOnRowReorder: onMenuItemsRowReorder
                          }, null, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (itemData.value.id > 0 && itemData.value.typeId !== _unref(EmailType).FreeFormat)
                  ? (_openBlock(), _createBlock(_unref(DxItem), {
                      key: 1,
                      title: "Adverts"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("section", _hoisted_5, [
                          _createVNode(EmailItemsComponent, {
                            "data-source": emailItems.value?.adverts,
                            "group-header": 'Adverts',
                            "alias-name": 'ad',
                            onRowClick: onAdvertsRowDbClick,
                            onRowSelected: onAdvertsRowSelected,
                            onMenuItemClick: onAdvertsDropdownClicked,
                            onOnRowReorder: onAdvertRowReorder
                          }, null, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (itemData.value.id > 0 && itemData.value.typeId == _unref(EmailType).Newsletter)
                  ? (_openBlock(), _createBlock(_unref(DxItem), {
                      key: 2,
                      title: "Articles"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("section", _hoisted_6, [
                          _createVNode(NewsletterComponent, {
                            "data-source": emailNewsletterItems.value,
                            onNewsLetterMenuItemClick: onNewsletterMenuItemClicked,
                            onNewsletterRowClick: onNewsletterRowDbClick,
                            onNewsletterRowSelected: onNewsletterRowSelected,
                            onOnRowReorder: onNewsLetterRowReorder
                          }, null, 8, ["data-source"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(DxItem), { title: "Attachments" }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_7, [
                      _createVNode(FileUpload, {
                        onFilesChanged: filesUpdated,
                        reset: resetAttachments.value,
                        readOnly: lockedByAnotherUser.value,
                        onFileDoubleClicked: downloadAttachment,
                        defaultFiles: filesDisplayed.value
                      }, null, 8, ["reset", "readOnly", "defaultFiles"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: "Preview" }, {
                  default: _withCtx(() => [
                    _createElementVNode("section", _hoisted_8, [
                      (itemData.value?.typeId == _unref(EmailType).PropertyBulletinAll ||
                            itemData.value?.typeId == _unref(EmailType).PropertyBulletinMatched ||
                            itemData.value?.typeId == _unref(EmailType).PropertyDetails ||
                            itemData.value?.typeId == _unref(EmailType).Newsletter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(ScrollView, null, {
                              default: _withCtx(() => [
                                _createVNode(DisplayHtml, {
                                  "html-content": emailPreviewFields.value.body
                                }, null, 8, ["html-content"])
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createBlock(HtmlEditor, {
                            key: 1,
                            modelValue: previewFieldValue.value,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((previewFieldValue).value = $event)),
                            readOnly: true,
                            height: "435px"
                          }, null, 8, ["modelValue"]))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["selectedIndex"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "before",
          options: { text: 'Insert Field', visible: selectedTab.value == 1, disabled: lockedByAnotherUser.value, onClick: () => { insertField() } }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: 'Save', disabled: lockedByAnotherUser.value, onClick: (e) => { saveDetails(e) }, validationGroup: 'EmailsValidationGroup' }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: 'Cancel', onClick: () => { cancelClick() } }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt", "width"]),
    _createVNode(AITextGeneratorModal, {
      modelValue: displayAIModal.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((displayAIModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(MergeFieldsModal, {
      modelValue: openMergeFieldsModal.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((openMergeFieldsModal).value = $event)),
      onAddMergeField: addMergeField
    }, null, 8, ["modelValue"]),
    _createVNode(EmailSignaturesConfigurationModal, {
      modelValue: displaySignaturesModal.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((displaySignaturesModal).value = $event)),
      onSignatureSelected: signatureSelected,
      "displayed-in-configuration-screen": false
    }, null, 8, ["modelValue"]),
    _createVNode(MailshotItemModal, {
      modelValue: displayMailshotModal.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((displayMailshotModal).value = $event)),
      "action-key": emailItemActionKey.value,
      "email-id": __props.configurationId,
      "item-type": emailItemType.value,
      "selected-email-item": selectedEmailItem.value,
      "total-adverts": emailItems.value?.adverts.length,
      "total-menu-items": emailItems.value?.menuItems.length,
      onRefreshEmailItemsData: onRefreshEmailItemsData
    }, null, 8, ["modelValue", "action-key", "email-id", "item-type", "selected-email-item", "total-adverts", "total-menu-items"]),
    _createVNode(NewsletterArticleModal, {
      modelValue: displayNewsletterModal.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((displayNewsletterModal).value = $event)),
      "action-key": newsletterActionKey.value,
      "total-newsletters": emailNewsletterItems.value.length,
      "email-id": __props.configurationId,
      "selected-newsletter-item": selectedNewsletterItem.value,
      onRefreshNewsletterData: onRefreshNewsletterData
    }, null, 8, ["modelValue", "action-key", "total-newsletters", "email-id", "selected-newsletter-item"])
  ], 64))
}
}

})